import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function DreamSection() {
  return <section className="py-24 bg-sage/10 relative overflow-hidden" data-id="element-42">
      <div className="absolute top-0 right-0 -mr-20 -mt-20 w-96 h-96 bg-sage/20 rounded-full blur-3xl opacity-50 pointer-events-none" data-id="element-43" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-44">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-45">
          <div className="inline-flex items-center justify-center p-3 bg-white rounded-full shadow-sm mb-8" data-id="element-46">
            <Sparkles className="h-6 w-6 text-terracotta" data-id="element-47" />
          </div>

          <h2 className="text-3xl md:text-5xl font-bold text-forest mb-8 font-serif leading-tight" data-id="element-48">
            Imagina esto:
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-forest/80 leading-relaxed max-w-3xl mx-auto" data-id="element-49">
            <p data-id="element-50">Son las 2AM. Tu hijo tiene fiebre.</p>

            <p data-id="element-51">
              Y tú... abres una guía. Encuentras el síntoma exacto. Ves el
              protocolo.{' '}
              <span className="font-bold text-forest" data-id="element-52">
                Paso 1. Paso 2. Paso 3.
              </span>
            </p>

            <p data-id="element-53">Sin dudar. Sin buscar. Sin entrar en pánico.</p>

            <p className="font-medium text-forest" data-id="element-54">
              Solo tú, tu hijo, y claridad absoluta sobre qué hacer primero.
            </p>

            <div className="py-8" data-id="element-55">
              <p className="text-2xl font-serif text-terracotta italic" data-id="element-56">
                "Esa es la mamá que quieres ser. No la mamá perfecta — la mamá
                preparada."
              </p>
            </div>

            <p className="font-bold text-forest text-xl" data-id="element-57">
              Y la diferencia entre esas dos versiones de ti... es tener las
              herramientas correctas en el momento correcto.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}